import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BanknoteIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Banknote`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 8h.007M4 8h.007M8 9.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666Z"
    />
    <Rect
      width={13.333}
      height={8}
      x={1.333}
      y={4}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={1}
    />
  </Icon>
);
